import React from "react";
import PropTypes from "prop-types";
import defaultStyle from "../../../utils/default";


function Heading({ title, color }) {
  return (
    <h2
      style={{
        color: color?.color?.primary || defaultStyle.color.primary,
        fontSize: "18px",
        fontWeight: 600,
        textAlign: "center",
        marginTop:"8px",
        paddingTop:"8px"
      }}
    >
      {title}
    </h2>
  );
}

Heading.propTypes = {
  title: PropTypes.string,
  Style: PropTypes.object,
};

export default Heading;
